<template>
  <q-list separator>
    <q-item>
      <div class="full-width column">
        <q-input outlined dense v-model="value.altText" placeholder="代替テキスト" class="full-width q-mb-md" disable />
        <q-btn
          no-caps
          class="btn-upload full-width"
          label="フレックスメッセージを編集する"
          @click="flexModalVisible = true"
        />
      </div>
      <FlexMessageModal
        v-if="flexModalVisible"
        :flexAnwser="value"
        :modalVisible="flexModalVisible"
        @update:data="updateData"
        @update:closeModal="onCloseModal"
      />
    </q-item>
  </q-list>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexAnswer } from '@/utils/types'
import FlexMessageModal from '@/components/common/flex-message/FlexMessageModal.vue'

@Options({
  components: { FlexMessageModal },
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class FlexSelector extends Vue {
  @Prop()
  modelValue!: IFlexAnswer

  flexModalVisible = false

  get value() {
    return this.modelValue
  }

  set value(value: IFlexAnswer) {
    this.$emit('update:modelValue', value)
  }

  updateData(value: IFlexAnswer) {
    this.value = value
  }

  onCloseModal() {
    this.flexModalVisible = false
  }
}
</script>

<style scoped lang="scss">
</style>
